import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import * as lodash from 'lodash';

export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/ApprovalCondition/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one condition.');
  }
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ approvalConditionAddFromTemplateShow: true });
  component.approvalConditionAddFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.approvalConditionAddFromTemplate.current?.formRef.current?.resetFields();
    component.approvalConditionAddFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], approvalConditionTemplatePresetContentList: [] });
    setTimeout(() => {
      component.approvalConditionAddFromTemplate.current?.additionalFormRef.current?.child.current?.getApprovalConditionTemplateData();
      component.approvalConditionAddFromTemplate.current?.getApprovalConditionTemplatePresetDataSource();
      console.log(component.approvalConditionAddFromTemplate.current?.additionalFormRef.current?.child.current);
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function manageApprovalConditionFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageFolderShow: true });
  sectionComponent.child.current?.manageFolder.current?.getApprovalConditionFolderList();
}

export function addApprovalCondition({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });
  }, config.setTimeoutMilliSecond);
}

export function collapseFolder({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    if (folder.key === key) {
      if (folder.Collapsed !== true) {
        folder.Collapsed = true;
      } else {
        folder.Collapsed = false;
      }
    }
    return folder;
  });
  component.setState({ data });
}

//收起所有folder
export function collapseAllFolders({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let data = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.Collapsed = true;
    return folder;
  });
  sectionComponent.child.current?.setState({ data });
}

//打开ChangeFolder弹窗
export function openChangeFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    let data = [];
    sectionComponent.child.current?.state.data.map((folder, i) => {
      folder.ApprovalConditionList.map((ApprovalCondition, j) => {
        if (sectionComponent.child.current?.state.selectedRowKeys.indexOf(ApprovalCondition.key) >= 0) {
          data.push(lodash.cloneDeep(ApprovalCondition));
        }
      })
    })

    sectionComponent.child.current?.setState({ changeFolderShow: true });

    httpClient
      .get('Business/ApprovalConditionFolder/GetSelectOptionList?approvalId=' + pageComponent.props.approvalId)
      .then(({ data }) => {
        if (data.result) {
          let componentDataSource = [];
          componentDataSource.ApprovalConditionFolderId = data.data;
          sectionComponent.child.current?.changeFolder.current?.setState({ componentDataSource });
          sectionComponent.child.current?.changeFolder.current?.formRef.current?.setFieldsValue({ 'ApprovalConditionFolderId': data.data[0].Value });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    message.warning('You must select at least one record.');
  }
}
